// extracted by mini-css-extract-plugin
export default {"default-button-create":"ButtonCreateReceipt_default-button-create__uVObD","default-button-create--icon":"ButtonCreateReceipt_default-button-create--icon__Dtiy9"};